import React, {Component} from "react";

import Asbestos from "./Asbestos";
import Biological from "./Biological";
import Environmental from "./Environmental";
import Ergonomic from "./Ergonomic";
import OccupationalHealthAndSafety from "./OccupationalHealthAndSafety";
import ManagementOfChange from "./ManagementOfChange";
import RouteRiskAssessment from "./RouteRiskAssessment";

export default class RenderTemplate  extends Component{

    constructor(props) {
        super(props);
    }


    render(){

        const {
            data,
            risk
        } = this.props;

        return(
            <div>
                {
                    data?
                        (
                            <div>
                                <div key={`${risk.type}_${data.id}`}>
                                    {
                                        risk.type === 'occupational_health'?
                                            <OccupationalHealthAndSafety
                                                model={risk}
                                                id={data.id}
                                                data={data}/>:null
                                    }
                                    {
                                        risk.type === 'management_of_change'?
                                            <ManagementOfChange
                                                id={data.id}
                                                model={risk}
                                                data={data}/>: null
                                    }
                                    {
                                        risk.type === 'biological'?
                                            <Biological
                                                id={data.id}
                                                model={risk}
                                                data={data}/>: null
                                    }
                                    {
                                        risk.type === 'ergonomic'?
                                            <Ergonomic
                                                id={data.id}
                                                model={risk}
                                                data={data}/>: null
                                    }
                                    {
                                        risk.type === 'environmental'?
                                            <Environmental
                                                id={data.id}
                                                model={risk}
                                                data={data}/>: null
                                    }
                                    {
                                        risk.type === 'asbestos'?
                                            <Asbestos
                                                id={data.id}
                                                model={risk}
                                                data={data}/>: null
                                    }
                                    {
                                        risk.type === 'route_risk_assessment'?
                                            <RouteRiskAssessment
                                                id={data.id}
                                                model={risk}
                                                data={data}/>: null
                                    }
                                </div>
                            </div>
                        ):
                        (
                            <p>An error occurred!</p>
                        )
                }
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/screens/risks/lists/RenderTemplate.js